module.exports = __webpack_public_path__ + "static/img/h4-5.74fd6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h4-5.png
// module id = +laL
// module chunks = 1